var render = function render(_c, _vm) {
  return _c(
    "svg",
    {
      attrs: {
        width: "17px",
        height: "16px",
        viewBox: "0 0 17 16",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
      },
    },
    [
      _c("title", [_vm._v("Radio")]),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "------Icons",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd",
          },
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Icons",
                transform: "translate(-559.000000, -190.000000)",
              },
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "radio",
                    transform: "translate(559.333178, 190.000000)",
                  },
                },
                [
                  _c("rect", {
                    attrs: {
                      id: "Rectangle",
                      x: "0",
                      y: "0",
                      width: "16",
                      height: "16",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      id: "Colour",
                      d: "M3.625,11.0716808 C3.86481481,10.780832 3.78703704,10.4238811 3.5212963,10.1264221 C2.73703704,9.2340449 2.30277778,8.00454746 2.30277778,6.65606641 C2.30277778,5.31419555 2.73703704,4.07808792 3.5212963,3.19232095 C3.78703704,2.89486189 3.86481481,2.53791103 3.625,2.24706217 C3.37222222,1.92977251 2.93148148,1.89672151 2.58148148,2.27350298 C1.58333333,3.35096578 1,4.97046509 1,6.65606641 C1,8.34827793 1.54444444,9.92811603 2.58148148,11.0386298 C2.93148148,11.4154113 3.37222222,11.3823603 3.625,11.0716808 Z M13.425,11.0386298 C14.4555556,9.92811603 15,8.34827793 15,6.65606641 C15,4.97046509 14.4296296,3.35096578 13.425,2.27350298 C13.075,1.89672151 12.6342593,1.92977251 12.375,2.24706217 C12.1351852,2.53791103 12.2194444,2.89486189 12.4787037,3.19232095 C13.2694444,4.07808792 13.7037037,5.31419555 13.7037037,6.65606641 C13.7037037,8.00454746 13.2694444,9.2340449 12.4787037,10.1264221 C12.2194444,10.4238811 12.1351852,10.780832 12.375,11.0716808 C12.6342593,11.3823603 13.075,11.4154113 13.425,11.0386298 Z M5.56296296,9.20099389 C5.78333333,8.91675524 5.70555556,8.56641457 5.49166667,8.26234531 C5.18703704,7.86573324 4.99907407,7.23776412 4.99907407,6.65606641 C4.99907407,6.0743687 5.2,5.45300978 5.49166667,5.0497875 C5.70555556,4.74571825 5.78333333,4.40198778 5.56296296,4.11774913 C5.31666667,3.80045947 4.84351852,3.78723906 4.52592593,4.14418993 C3.99444444,4.77215905 3.6962963,5.68436682 3.6962963,6.65606641 C3.6962963,7.62776599 3.99444444,8.53997376 4.52592593,9.16794288 C4.84351852,9.52489375 5.31666667,9.51167335 5.56296296,9.20099389 Z M11.4805556,9.16794288 C12.012037,8.53997376 12.3037037,7.62776599 12.3037037,6.65606641 C12.3037037,5.68436682 12.012037,4.77215905 11.4805556,4.14418993 C11.162963,3.78723906 10.6898148,3.80045947 10.4435185,4.11774913 C10.2231481,4.40198778 10.3009259,4.74571825 10.5148148,5.0497875 C10.8064815,5.45300978 11.0074074,6.0743687 11.0074074,6.65606641 C11.0074074,7.23776412 10.812963,7.86573324 10.5148148,8.26234531 C10.3009259,8.56641457 10.2231481,8.91675524 10.4435185,9.20099389 C10.6898148,9.51167335 11.162963,9.52489375 11.4805556,9.16794288 Z M8,14 C8.38888889,14 8.6287037,13.7157613 8.6287037,13.2794881 L8.6287037,7.83268223 C9.03703704,7.60793539 9.31574074,7.1650519 9.31574074,6.65606641 C9.31574074,5.91572387 8.73240741,5.31419555 8,5.31419555 C7.27407407,5.31419555 6.69074074,5.91572387 6.69074074,6.65606641 C6.69074074,7.1650519 6.96296296,7.60793539 7.37777778,7.83268223 L7.37777778,13.2794881 C7.37777778,13.7025409 7.63703704,14 8,14 Z",
                      fill: "#2F477C",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }